import SeoHead, { SITE_URL } from '@/components/feature/SeoHead';
import HeroSection from './components/HeroSection';
import ServicesSection from './components/ServicesSection';
import WhyUsSection from './components/WhyUsSection';
import CasesSection from './components/CasesSection';
import KnowledgePreview from './components/KnowledgePreview';
import FAQSection from './components/FAQSection';
import CtaBanner from './components/CtaBanner';

const homeJsonLd = [
  {
    '@context': 'https://schema.org',
    '@type': 'MedicalClinic',
    name: 'RTB吉尔吉斯斯坦试管代孕中心',
    description: '专业提供代孕服务、试管婴儿（IVF）、捐精捐卵服务及法律支持，500+成功案例，全程中文顾问。',
    url: SITE_URL,
    telephone: '+8616600032397',
    email: 'ivfjason@gmail.com',
    address: {
      '@type': 'PostalAddress',
      addressLocality: 'Bishkek',
      addressCountry: 'KG',
    },
    geo: {
      '@type': 'GeoCoordinates',
      latitude: '42.8746',
      longitude: '74.5698',
    },
    medicalSpecialty: 'ReproductiveMedicine',
    openingHoursSpecification: [
      {
        '@type': 'OpeningHoursSpecification',
        dayOfWeek: ['Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday'],
        opens: '09:00',
        closes: '18:00',
      },
    ],
    sameAs: [],
  },
  {
    '@context': 'https://schema.org',
    '@type': 'FAQPage',
    mainEntity: [
      {
        '@type': 'Question',
        name: '吉尔吉斯斯坦代孕是否合法？',
        acceptedAnswer: { '@type': 'Answer', text: '吉尔吉斯斯坦是少数法律明确允许商业代孕的国家之一，委托方自孩子出生起即被登记为法定父母，享有完整亲权。' },
      },
      {
        '@type': 'Question',
        name: '代孕流程需要多长时间？',
        acceptedAnswer: { '@type': 'Answer', text: '从胚胎移植到孩子出生约9-10个月，加上前期准备（志愿者筛选、医疗检查等），整体周期通常为12-16个月。' },
      },
      {
        '@type': 'Question',
        name: '代孕费用是多少？',
        acceptedAnswer: { '@type': 'Answer', text: '单助孕方案惠享$63,600起/安心$71,600起；试管助孕全链条方案惠享$82,000起/安心$89,800起/无忧$102,000起。实际费用因方案选择而异。' },
      },
      {
        '@type': 'Question',
        name: '如何确保代孕志愿者的健康？',
        acceptedAnswer: { '@type': 'Answer', text: '所有志愿者需通过三重健康筛查认证，包括血检、传染病检测、妇科检查及心理健康评估，确保身体健康状况符合标准。' },
      },
      {
        '@type': 'Question',
        name: '孩子出生后的证件如何办理？',
        acceptedAnswer: { '@type': 'Answer', text: 'RTB协助办理DNA亲子鉴定、出生医学证明、海牙公证、回国签证及旅行证等全套手续，确保顺利带宝宝回国。' },
      },
    ],
  },
  {
    '@context': 'https://schema.org',
    '@type': 'WebSite',
    name: 'RTB吉尔吉斯斯坦试管代孕中心',
    url: SITE_URL,
    potentialAction: {
      '@type': 'SearchAction',
      target: `${SITE_URL}/news?search={search_term_string}`,
      'query-input': 'required name=search_term_string',
    },
  },
];

export default function HomePage() {
  return (
    <>
      {/* useDbSeo=true → loads title/description/keywords from site_settings DB */}
      <SeoHead
        canonical="/"
        jsonLd={homeJsonLd}
        useDbSeo
      />
      <main>
        <HeroSection />
        <ServicesSection />
        <WhyUsSection />
        <CasesSection />
        <KnowledgePreview />
        <FAQSection />
        <CtaBanner />
      </main>
    </>
  );
}